<template>
  <div>

    <v-stepper-step :complete="current > step" :step="step" :editable="!!style" color="#FF696F" :id="`project-step-${step}`">
      Quel style d'aménagement appréciez-vous le plus ? <span class="overline">{{style}}</span>
    </v-stepper-step>

    <v-stepper-content :step="step">
      <component :is="styleComponent" @change="onDataUpdate"/>
    </v-stepper-content>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { constantes } from '../../store/app'

import StyleHortusBox from './StyleHortusBox'
import StyleLeroyMerlin from './StyleLeroyMerlin'

export default {
  model: { prop: 'data', event: 'change' },
  props: {
    data: String,
    step: Number,
    current: Number
  },
  components: { StyleHortusBox, StyleLeroyMerlin },
  computed: {
    ...mapGetters('app', ['host']),
    styleComponent: function () {
      let style = 'StyleHortusBox'
      switch (this.host) {
        case constantes.HostLeroyMerlin: style = 'StyleLeroyMerlin'; break
      }
      return style
    }
  },
  data: () => ({
    style: ''
  }),
  methods: {
    onDataUpdate (val) {
      this.$emit('change', val)
    }
  },
  beforeMount () {
    this.style = this.data
  }
}
</script>